<div class="packlists-container">
  <mic-breadcrumb>
    <mic-breadcrumb-link
      link="/home/dashboard"
      icon="home"
      ariaLabel="{{ translationService.translate('homeText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/packlists" label="{{ this.translationService.translate('packListsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title packlists-heading">{{ this.translationService.translate('packListsText') }}</h2>

  <mat-card>
    <mat-card-content id="packlist-table" class="cam-table">
      <form [formGroup]="packListFilterForm">
        <div class="filter-container">
          <mat-form-field appearance="fill" class="filter-item pack-list-number-field">
            <mat-label>{{ this.translationService.translate('packListNumberText') }}</mat-label>
            <input
              matInput
              formControlName="packListNumber"
              placeholder="{{ this.translationService.translate('enterPackListNumberText') }}"
            />
          </mat-form-field>
          <div class="filter-item source-field">
            <mic-dropdown-search
              micDropdownAccessibility
              formControlName="source"
              [widthConfig]="{ width: '100%', maxWidth: '300px' }"
              [data]="sourceList"
              label="{{ this.translationService.translate('sourceText') }}"
              searchPlaceholder="Search"
              subscriptSizing="dynamic"
              [multiple]="false"
              allLabel="All"
            >
            </mic-dropdown-search>
          </div>
          <div class="filter-item status-field">
            <mat-form-field appearance="fill" subscriptSizing="dynamic">
              <mat-label>{{ this.translationService.translate('statusColumnText') }}</mat-label>
              <mat-select formControlName="status" placeholder="{{ translationService.translate('statusColumnText') }}">
                @for (status of statusList; track status) {
                <mat-option [value]="status">
                  {{ status }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field appearance="fill" class="filter-item received-date-field">
            <mat-label>{{ this.translationService.translate('receivedDateText') }}</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker">
              <input
                matStartDate
                placeholder="{{ translationService.translate('receivedDateText') }}"
                autocomplete="off"
                formControlName="receivedDateStart"
              />
              <input
                matEndDate
                placeholder="{{ translationService.translate('receivedDateText') }}"
                autocomplete="off"
                formControlName="receivedDateEnd"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker></mat-date-range-picker>
          </mat-form-field>
          <button
            id="reset-filters"
            type="button"
            (click)="clearSelection()"
            mat-flat-button
            color="accent"
            class="mic-btn-lg reset-filter btn-clear"
            [attr.aria-label]="translationService.translate('clearSelectionText')"
          >
            <mat-icon role="img" aria-label="refresh">refresh</mat-icon>
            {{ this.translationService.translate('clearSelectionText') }}
          </button>
          <button
            mat-flat-button
            color="primary"
            class="btn-primary print-selected-button"
            type="button"
            (click)="openPrintSelectedModal()"
            [disabled]="selection.length === 0 || isBulkExportInProgress"
          >
            @if (isBulkExportInProgress) {
            <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
            } @else {
            <mat-icon>print</mat-icon>
            }
            <span>{{ this.translationService.translate('printSelectedText') }}</span>
          </button>
        </div>
        <div class="filter-container customer-filter-container">
          <button
            mat-flat-button
            color="primary"
            class="mic-btn-icon-left btn-primary customer-search-button"
            (click)="openCustomerModal()"
            type="button"
          >
            <mat-icon>search</mat-icon>
            <span>{{ this.translationService.translate('searchCustomerText') }}</span>
          </button>
          <mat-form-field subscriptSizing="dynamic" class="filter-item customer-code-field">
            <mat-label>{{ this.translationService.translate('customerCodeText') }}</mat-label>
            <input matInput type="text" formControlName="customerCode" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic" class="filter-item customer-name-field">
            <mat-label>{{ this.translationService.translate('customerNameText') }}</mat-label>
            <input matInput type="text" formControlName="customerName" [disabled]="true" />
          </mat-form-field>
        </div>
      </form>

      <div class="table-wrapper btn-table">
        <mic-table appCopyOnSelect class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
          <ng-container *micTableNoData>
            <mic-empty-state icon="layers_clear" [title]="translationService.translate('emptyTableText')"></mic-empty-state>
          </ng-container>
          <ng-container *micCellTemplate="let item; name: 'action'">
            @if (!(productSaveDisabled || !(!productSaveDisabled && item.packListTotalItems === 0))) {
            <div class="centered-cell">
              <button
                mat-icon-button
                class="btn-delete"
                (click)="showDeleteModal(item)"
                [attr.aria-label]="translationService.translate('deleteText')"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
            }
          </ng-container>
        </mic-table>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<mic-modal #customerModal></mic-modal>
<ng-template #customerModalContent>
  <mic-customer-select-model [dealerId]="dealer?.id" [userLogin]="userLogin" [plantId]="plantId" (result)="onCustomerSelected($event)">
  </mic-customer-select-model>
</ng-template>

<mic-modal class="modalC" #deleteModal (result)="onDeleteModalClosed($event)"></mic-modal>

<ng-template #deleteConfirmation
  >{{ translationService.translate('deleteCamSpecModalContentLine1Text') }} <b>{{ packListNum }}</b
  >? {{ translationService.translate('deleteCamSpecModalContentLine2Text') }}</ng-template
>
